// extracted by mini-css-extract-plugin
export default {"content":"page_layout-module__content--7qxng"};